import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "ngp_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      // Delay a bit so hero animations don't compete with the banner
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const persist = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, ts: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 inset-x-4 md:inset-x-auto md:left-6 md:right-auto md:max-w-lg z-[60] border border-ng-line bg-ng-surface/95 backdrop-blur-xl p-5 md:p-6 shadow-[0_0_60px_-20px_rgba(30,144,255,0.5)] animate-in slide-in-from-bottom fade-in duration-500"
    >
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 border border-ng-blue/40 flex items-center justify-center text-ng-blue flex-shrink-0">
          <Cookie size={18} strokeWidth={1.5} />
        </div>
        <div className="flex-1">
          <div className="label-eyebrow mb-1">Heads up</div>
          <p className="text-white/75 text-sm font-light leading-relaxed">
            We use cookies for essential site functionality and privacy-friendly
            analytics. See our{" "}
            <Link
              to="/privacy"
              className="text-ng-blue hover:underline font-medium"
              data-testid="cookie-privacy-link"
            >
              Privacy Policy
            </Link>{" "}
            for details.
          </p>

          <div className="mt-4 flex flex-wrap gap-2">
            <button
              type="button"
              data-testid="cookie-accept"
              onClick={() => persist("accepted")}
              className="bg-ng-blue text-white px-5 py-2.5 uppercase tracking-[0.2em] text-[11px] font-bold font-display hover:bg-ng-blueLight transition-colors"
            >
              Accept
            </button>
            <button
              type="button"
              data-testid="cookie-essential"
              onClick={() => persist("essential")}
              className="border border-ng-line text-white/80 px-5 py-2.5 uppercase tracking-[0.2em] text-[11px] font-bold font-display hover:border-ng-blue hover:text-ng-blue transition-colors"
            >
              Essential only
            </button>
          </div>
        </div>
        <button
          type="button"
          data-testid="cookie-close"
          onClick={() => persist("essential")}
          aria-label="Dismiss"
          className="text-white/40 hover:text-white transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
